import {
  getList as getListV1,
  markAsRead as markAsReadV1,
} from '../services/notifications';
import { getProviderMode } from './bootstrap';
import * as inbox from './inboxService';
import { deliversWithFcm } from './modes';

/**
 * The single place the site decides which inbox backs the Notifications screen: V2 when the brand
 * delivers with FCM, V1 otherwise. Opening from the inbox marks `read`; it never reports a direct
 * open.
 */
export const usesV2Inbox = () => deliversWithFcm(getProviderMode());

export const listNotifications = async () => {
  if (usesV2Inbox()) {
    return { notifications: await inbox.list() };
  }
  return getListV1();
};

export const markNotificationsRead = async (ids = []) => {
  if (!ids.length) {
    return true;
  }
  if (usesV2Inbox()) {
    await inbox.markRead(ids);
    return true;
  }
  return markAsReadV1(ids);
};

export const markAllNotificationsRead = async (ids = []) => {
  if (usesV2Inbox()) {
    await inbox.markAllRead();
    return true;
  }
  return markAsReadV1(ids);
};

export const unreadNotifications = async fallback => {
  if (usesV2Inbox()) {
    return inbox.unreadCount();
  }
  return fallback;
};
